module.exports = __webpack_public_path__ + "static/media/atividades.e6cacacb.svg";